// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"995":"066e8381","1970":"066e8381","2327":"066e8381","2904":"066e8381","3105":"066e8381","3497":"066e8381","5038":"066e8381","8107":"066e8381"}[chunkId] + ".chunk.css";
};